// 9fbef606107a605d69c0edbcd8029e5d
export const getStyliticsProductTabListSelector = (state) => state.StyliticsProductTabList;

export const getOutfitPLPData = (state) => state?.StyliticsProductTabList?.oufitPLPData;

export const getOutfitPlpSEOData = (state) => {
  return state?.StyliticsProductTabList?.outfitSeoData;
};

export const getBagOutfitProducts = (state) => {
  return state?.StyliticsProductTabList?.bagPageOutfitProducts;
};

export default {
  getStyliticsProductTabListSelector,
  getOutfitPLPData,
};
